import * as React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import { manageSecurity } from '../actions/manageSecurity';
import { viewActivity } from '../actions/viewActivity';
import { OptionDescription } from 'owa-options-controls';

const styles = require('./AccountSecurityOptionFull.scss');

export default class SecurityManageOptionFull extends React.Component<{}, {}> {
    render() {
        return (
            <div>
                <div className={styles.securityManageContainer}>
                    <div>
                        <OptionDescription>
                            {strings.options_premium_AdvancedSecurityContent_part2}
                        </OptionDescription>
                    </div>
                    <div className={styles.securityManage_btn_container}>
                        <PrimaryButton
                            text={strings.options_premium_buttonText}
                            data-is-focusable={true}
                            disabled={false}
                            onClick={manageSecurity}
                            className={styles.addNewItemButton}
                        />
                    </div>
                </div>
                <div className={styles.securityManageContainer}>
                    <div>
                        <OptionDescription>
                            {strings.options_premium_AdvancedSecurityContent_part3}
                        </OptionDescription>
                    </div>
                    <div className={styles.securityManage_btn_container}>
                        <PrimaryButton
                            text={strings.options_premium_AdvancedSecurityContent_View}
                            data-is-focusable={true}
                            disabled={false}
                            onClick={viewActivity}
                            className={styles.addNewItemButton}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
